import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/theme';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Tooltip: {
    position: 'absolute',
    width: 200,
    padding: spacing[5],
    backgroundColor: pricingPalette.colors.white,
    transform: 'translateX(10%)',
    top: -36,
    borderRadius: 2,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    zIndex: 1,
    '& h5': {
      fontWeight: type.fontWeight.medium,
      marginBottom: spacing[3],
    },
  },
  TooltipArrow: {
    width: 50,
    height: 25,
    position: 'absolute',
    top: 20,
    left: -37,
    transform: 'rotate(90deg)',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 20,
      height: 20,
      background: pricingPalette.colors.white,
      transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
      top: 0,
      left: '50%',
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    },
  },
}));
